  <div class="grid-container text-white text-weight-600">
  <div class="card">
    <span class="text-size-16 text-res">ACCESO</span>
    <sit-icon
      [icon]="Icon.access_green"
      alt="icono sentido de tramo"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.access }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">COSTADO</span>
    <sit-icon
      [icon]="Icon.side_green"
      alt="icono tramo"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.side }}</span>
  </div>

  <div class="card">
    <span class="text-size-16 text-res">OPERACIÓN</span>
    <sit-icon
      [icon]="Icon.operation_green"
      alt="icono semáforo"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.operation }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">TIPO DE POSTE</span>
    <sit-icon
      [icon]="Icon.poste_green"
      alt="icono poste"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.pole }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">TIPO DE BOMBILLA</span>
    <sit-icon
      [icon]="Icon.lightbulb_green"
      alt="icono bombilla"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.lightbulbType }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">SONORIZACIÓN</span>
    <sit-icon
      [icon]="Icon.sound_green"
      alt="icono oreja"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.sound }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">ACTIVO</span>
    <sit-icon
      [icon]="Icon.active_green"
      alt="icono semáforo"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.active }}</span>
  </div>
</div>
